import { render, staticRenderFns } from "./tab1.vue?vue&type=template&id=5c2cbf0a"
import script from "./tab1.vue?vue&type=script&lang=js"
export * from "./tab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports